import { ReactElement } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@fdoh/health-ui-react";
import SetBacksInspectionModule from "./pages/SetBacks/Module";
import DrainfieldInstallationInspectionModule from "./pages/DrainFieldInstallation/Module";
import CreateFillExcavationMaterialModule from "./pages/FillExcavationMaterial/module";
import InspectionModule from "./pages/InspectionHome/InspectionModule";
import TankInstallationModule from "./pages/TankInstallation/Module";
import HomeModule from "./pages/Home/Homemodule";
import DBProtectedRoute from "./components/DBProtectedRoute";
import AbandonmentModule from "./pages/Abandonment/Module";
import FilledMoundSystemInspectionModule from "./pages/FilledMoundSystem/Module";
import SubmitInspectionModule from "./pages/SubmitInspection.tsx/SubmitInspectionModule";
import SummaryViewModule from "./pages/Summary/SummaryModule";
import CreateAdditionalInformationModule from "./pages/AdditionalInformation/AdditionalInformationModule";
import SupportRequestModule from "./pages/SupportRequest/Module";
import UserTrainingViewModule from "./pages/Components/UserTrainings/UserTrainingModule";
import TrainingVideosModule from "./pages/Components/TrainingVideos/TrainingVideosModule";
import UserManagementModule from "./pages/UserManagement/Module";
import UserModule from "./pages/Components/UserForm/UserModule";
import SignUpPage from "./pages/PublicSignUp/SignUp";
import ProfilePage from "./pages/PublicSignUp/Profile";

export const Routes: ReactElement[] = [

    // Public route (outside MSAL/DB protection)
    <Route key="public-signup" path="/signup" exact>
        <SignUpPage />
    </Route>,

    <ProtectedRoute key="profile" path="/profile" exact>
        <DBProtectedRoute>
            <ProfilePage />
        </DBProtectedRoute>
    </ProtectedRoute>,

    <ProtectedRoute key="1" path="/" exact>
        <DBProtectedRoute>
            <HomeModule />
        </DBProtectedRoute>
    </ProtectedRoute>,
    <ProtectedRoute key="2" path="/setBacks">
        <DBProtectedRoute>
            <SetBacksInspectionModule />
        </DBProtectedRoute>
    </ProtectedRoute>,
    <ProtectedRoute key="3" path="/drainfieldInstallation">
        <DBProtectedRoute>
            <DrainfieldInstallationInspectionModule />
        </DBProtectedRoute>
    </ProtectedRoute>,
    <ProtectedRoute key="4" path="/fillExcavationMaterial">
        <DBProtectedRoute>
            <CreateFillExcavationMaterialModule />
        </DBProtectedRoute>
    </ProtectedRoute>,
    <ProtectedRoute key="5" path="/inspectionDetails">
        <DBProtectedRoute>
            <InspectionModule />
        </DBProtectedRoute>
    </ProtectedRoute>,
    <ProtectedRoute key="6" path="/filledMoundSystem">
        <DBProtectedRoute>
            <FilledMoundSystemInspectionModule />
        </DBProtectedRoute>
    </ProtectedRoute>,
    <ProtectedRoute key="7" path="/tankInstallation">
        <DBProtectedRoute>
            <TankInstallationModule />
        </DBProtectedRoute>
    </ProtectedRoute>,
    <ProtectedRoute key="8" path="/submitInspection">
        <DBProtectedRoute>
            <SubmitInspectionModule />
        </DBProtectedRoute>

    </ProtectedRoute>,
    <ProtectedRoute key="9" path="/summaryView">
        <DBProtectedRoute>
            <SummaryViewModule />
        </DBProtectedRoute>

    </ProtectedRoute>,
    <ProtectedRoute key="9b" path="/FinalInspectionSummaryView">
        <DBProtectedRoute>
            <SummaryViewModule />
        </DBProtectedRoute>
    </ProtectedRoute>,

    <ProtectedRoute key="10" path="/additionalInformation">
        <DBProtectedRoute>
            <CreateAdditionalInformationModule />
        </DBProtectedRoute>
    </ProtectedRoute>,
    <ProtectedRoute key="11" path="/abandonment">
        <DBProtectedRoute>
            <AbandonmentModule />
        </DBProtectedRoute>
    </ProtectedRoute>,
    <ProtectedRoute key="12" path="/supportRequest">
    <DBProtectedRoute>
        <SupportRequestModule />
    </DBProtectedRoute>
</ProtectedRoute>,
    <ProtectedRoute key="13" path="/userTrainings">
    <DBProtectedRoute>
        <UserTrainingViewModule />
    </DBProtectedRoute>
</ProtectedRoute>,
<ProtectedRoute key="14" path="/trainingVideos">
    <DBProtectedRoute>
        <TrainingVideosModule />
    </DBProtectedRoute>
</ProtectedRoute>,
  <ProtectedRoute key="15" path="/userManagement">
  <DBProtectedRoute>
      <UserManagementModule />
  </DBProtectedRoute>
</ProtectedRoute>,
<ProtectedRoute key="16" path="/userForm">
        <DBProtectedRoute>
            <UserModule />
        </DBProtectedRoute>
    </ProtectedRoute>,
];

export default Routes;
